import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../hacks.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../js/coreRuntime.mjs';
import { KTypeParameter1s8efufd4mbj5 as KTypeParameter } from './KTypeParameter.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KTypeParameterBaseClass;
function KTypeParameterBase() {
  if (KTypeParameterBaseClass === VOID) {
    class $ {
      toString() {
        var tmp;
        switch (this.u1().w1_1) {
          case 0:
            tmp = '';
            break;
          case 1:
            tmp = 'in ';
            break;
          case 2:
            tmp = 'out ';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp + this.h1();
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof KTypeParameterBase()) {
          tmp_0 = this.h1() === other.h1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.t1() === other.t1();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(getStringHashCode(this.t1()), 31) + getStringHashCode(this.h1()) | 0;
      }
    }
    initMetadataForClass($, 'KTypeParameterBase', VOID, VOID, [KTypeParameter()]);
    KTypeParameterBaseClass = $;
  }
  return KTypeParameterBaseClass;
}
//region block: exports
export {
  KTypeParameterBase as KTypeParameterBase70dfo08xyjmg,
};
//endregion

//# sourceMappingURL=KTypeParameterBase.mjs.map
